import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCuotasBySocio, updateCuotas } from '../actions/cuotaActions';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import './CuotasList.css';
import Swal from 'sweetalert2';
import '@sweetalert2/theme-dark/dark.css';
import ReciboModal from './ReciboModal';

const CuotasList = ({ showCuotasModal, closeCuotasModal, socio }) => {
    const dispatch = useDispatch();
    const { cuotas = [], loading, error } = useSelector(state => state.cuota);
    const [cuotasEditadas, setCuotasEditadas] = useState({});
    const [selectedCuotas, setSelectedCuotas] = useState([]);
    const [showReciboModal, setShowReciboModal] = useState(false);
    const [nroRecibo, setNroRecibo] = useState('');
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [printData, setPrintData] = useState({
        nroRecibo: '',
        fechaPago: new Date(),
        nombreSocio: '',
        cuotasPagadas: [],
        total: 0
    });

    useEffect(() => {
        if (socio && socio.id) {
            dispatch(fetchCuotasBySocio(socio.id));
        }
    }, [dispatch, socio]);

    useEffect(() => {
        if (cuotas && cuotas.length > 0) {
            const initialCuotasEditadas = {};
            cuotas.forEach(cuota => {
                if (cuota.estado === 0) {
                    initialCuotasEditadas[cuota.id] = {
                        ...cuota,
                        fepago: new Date(),
                        montopagado: cuota.monto
                    };
                }
            });
            setCuotasEditadas(initialCuotasEditadas);
        }
    }, [cuotas]);

    const handleAmountChange = (cuotaId, amount) => {
        const floatAmount = parseFloat(amount) || 0;
        setCuotasEditadas({
            ...cuotasEditadas,
            [cuotaId]: {
                ...cuotasEditadas[cuotaId],
                montopagado: floatAmount,
                fepago: cuotasEditadas[cuotaId]?.fepago || new Date()
            }
        });
    };

    const handleObservationChange = (cuotaId, observation) => {
        setCuotasEditadas({
            ...cuotasEditadas,
            [cuotaId]: {
                ...cuotasEditadas[cuotaId],
                observ: observation,
                fepago: cuotasEditadas[cuotaId]?.fepago || new Date()
            }
        });
    };

    const handleSelectCuota = (cuota) => {
        const isSelected = selectedCuotas.some(item => item.id === cuota.id);
    
        if (!isSelected) {
            const cuotasASeleccionar = sortedCuotas.filter(c => c.gestion <= cuota.gestion);
            
            const cuotasValidas = cuotasASeleccionar.filter(c => {
                const montoPagado = cuotasEditadas[c.id]?.montopagado ?? c.montopagado ?? c.monto;
                if (montoPagado <= 0) {
                    toast.error(`El monto pagado debe ser mayor que 0 para seleccionar la cuota ${c.gestion}`);
                    return false;
                }
                if (montoPagado < c.monto && !cuotasEditadas[c.id]?.observ) {
                    toast.error(`La observación es obligatoria si el monto pagado es menor que el monto en la cuota ${c.gestion}`);
                    return false;
                }
                return true;
            });
    
            const cuotasUnicas = cuotasValidas.map(c => ({
                ...c,
                fepago: new Date(),
                montopagado: cuotasEditadas[c.id]?.montopagado || c.monto,
            }));
    
            setSelectedCuotas(cuotasUnicas);
        } else {
            const cuotasRestantes = sortedCuotas.filter(c => c.gestion < cuota.gestion);
            setSelectedCuotas(cuotasRestantes);
        }
    };

    const handlePayment = async () => {
        console.log("Entro al payment...")
        const result = await Swal.fire({
            title: 'Confirmación de Pago para todo lo que es cuotas',
            text: 'Este es un proceso irreversible. ¿Está seguro de que desea continuar?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            focusCancel: true,
        });
    
        if (!result.isConfirmed) {
            toast.info("Operación cancelada.");
            return;
        }
    
        try {
            const cuotasData = selectedCuotas.map(cuota => ({
                id: cuota.id,
                montopagado: cuotasEditadas[cuota.id]?.montopagado || cuota.monto,
                fepago: cuotasEditadas[cuota.id]?.fepago || new Date(),
                observ: cuotasEditadas[cuota.id]?.observ || null
            }));
    
            const response = await dispatch(updateCuotas(socio.id, cuotasData));

            console.log("RESPONSE=", response.data.nrorec)
    
            if (!response.data.nrorec) {
                throw new Error('No se recibió un número de recibo válido del servidor');
            }
    
            const nrorec = response.data.nrorec;
            setNroRecibo(nrorec);
            setShowReciboModal(true);
            
            dispatch(fetchCuotasBySocio(socio.id));
            setSelectedCuotas([]);
            toast.success(response.message || "Pago realizado correctamente");
    
        } catch (error) {
            console.error("Error en el proceso de pago:", error);
            if (error.response && error.response.data && error.response.data.message) {
                toast.error(`Error: ${error.response.message}`);
            } else {
                toast.error(error.message || "Ocurrió un error al procesar el pago");
            }
        }
    };

    const handleClosePrintModal = () => {
        setShowPrintModal(false);
        closeCuotasModal(false);
    };

    if (loading) return <div>Cargando cuotas...</div>;
    if (error) return <div>Error al cargar las cuotas: {error}</div>;
    if (!Array.isArray(cuotas)) return <div>No hay cuotas disponibles</div>;

    const sortedCuotas = [...cuotas]
        .filter(cuota => cuota.estado === 0)
        .sort((a, b) => new Date(a.feemis) - new Date(b.feemis));

    return (
        <>
            <Modal show={showCuotasModal} onHide={() => closeCuotasModal(false)} backdrop="static" keyboard={false} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Cuotas del Socio</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="socio-info">
                        <div className='row'>
                            <div className='col-auto'>
                                <p><strong>CÓDIGO DE REGISTRO:</strong></p>
                                <p><strong>APELLIDO PATERNO:</strong> </p>
                                <p><strong>APELLIDO MATERNO:</strong></p>
                                <p><strong>NOMBRES:</strong> </p>
                                <p><strong>N° CÉDULA DE IDENTIDAD:</strong> </p>
                            </div>
                            <div className='col w-auto'>
                                <p> {socio.codreg}</p>
                                <p> {socio.apPat}</p>
                                <p> {socio.apMat}</p>
                                <p> {socio.nombres}</p>
                                <p> {socio.ci}</p>
                            </div>
                        </div>
                    </div>
                    <div className="cuotas-container" style={{ overflowX: 'auto' }}>
                        <div className="cuotas-list">
                            <table className="cuotas-table">
                                <thead>
                                    <tr>
                                        <th>Gestión</th>
                                        <th>F.Emisión</th>
                                        <th>Monto</th>
                                        <th>F.Pago</th>
                                        <th>M_a_Pagar</th>
                                        <th>Obser.</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sortedCuotas.map(cuota => {
                                        const cuotaEditada = cuotasEditadas[cuota.id] || {};
                                        const isSelected = selectedCuotas.some(item => item.id === cuota.id);
                                        return (
                                            <tr key={cuota.id}>
                                                <td>{cuota.gestion}</td>
                                                <td>{new Date(cuota.feemis).toLocaleDateString()}</td>
                                                <td>{cuota.monto.toFixed(2)}</td>
                                                <td>{(cuotaEditada.fepago || cuota.fepago) ? new Date(cuotaEditada.fepago || cuota.fepago).toLocaleDateString() : 'N/A'}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        value={cuotaEditada.montopagado ?? cuota.montopagado ?? cuota.monto}
                                                        onChange={(e) => handleAmountChange(cuota.id, e.target.value)}
                                                        disabled={cuota.estado !== 0 || isSelected}
                                                        step="0.01"
                                                    />
                                                </td>
                                                <td style={{ width: '300px' }}>
                                                    <input
                                                        type="text"
                                                        value={cuotaEditada.observ || cuota.observ || ''}
                                                        onChange={(e) => handleObservationChange(cuota.id, e.target.value)}
                                                        disabled={cuota.estado !== 0 || isSelected}
                                                    />
                                                </td>
                                                <td>
                                                    {cuota.estado === 0 && (
                                                        <input
                                                            type="checkbox"
                                                            checked={isSelected}
                                                            onChange={() => handleSelectCuota(cuota)}
                                                        />
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="summary-panel">
                            <h5><strong>Resumen</strong></h5>
                            <p><strong>Cuotas seleccionadas:</strong> {selectedCuotas.length}</p>
                            <p><strong>Monto total a pagar:</strong> 
                                {selectedCuotas.reduce((sum, item) => sum + (cuotasEditadas[item.id]?.montopagado || item.monto), 0).toFixed(2)}
                            </p>
                            <button 
                                className="button btn-success" 
                                onClick={handlePayment} 
                                disabled={selectedCuotas.length === 0}
                            >
                                Confirmar Pago
                            </button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="button btn-cancel" onClick={() => closeCuotasModal(false)}>
                        <i className="bi bi-arrow-left"></i> Volver
                    </button>
                </Modal.Footer>
            </Modal>

            <ReciboModal
                show={showReciboModal}
                handleClose={() => {
                    setShowReciboModal(false);
                    closeCuotasModal(false);
                }}
                nroRecibo={nroRecibo}
            />
        </>
    );
};

export default CuotasList;